import {
    StrategicPlanningActionPlanIcon,
    StrategicPlanningGoalIcon,
    StrategicPlanningObjectiveIcon,
    StrategicPlanningProjectIcon,
} from "@/config";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Button, Container, ListItemIcon, Menu, MenuItem, Stack } from "@mui/material";
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import ObjectiveCard from "./ObjectionCard";

export default function StrategicPlanningViewer(props) {
    const { strategicPlanning } = useOutletContext();
    const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
    const actionMenuOpen = Boolean(actionMenuAnchorEl);
    const handleClickActionMenu = (event) => {
        setActionMenuAnchorEl(event.currentTarget);
    };
    const handleCloseActionMenu = () => {
        setActionMenuAnchorEl(null);
    };

    // const ActionMenuButton = (
    //     <Button
    //         // disableElevation
    //         variant="contained"
    //         endIcon={<KeyboardArrowDownIcon />}
    //         onClick={handleClickActionMenu}
    //     >
    //         Create
    //     </Button>
    // );

    // const ActionMenu = (
    //     <Menu
    //         anchorEl={actionMenuAnchorEl}
    //         open={actionMenuOpen}
    //         onClick={handleCloseActionMenu}
    //         onClose={handleCloseActionMenu}
    //         // elevation={1}
    //         anchorOrigin={{
    //             vertical: "bottom",
    //             horizontal: "right",
    //         }}
    //         transformOrigin={{
    //             vertical: "top",
    //             horizontal: "right",
    //         }}
    //         sx={{ width: 300 }}
    //     >
    //         {/**
    //             NOTE: indent text
    //             <MenuItem>
    //                 <ListItemText inset>Single</ListItemText>
    //             </MenuItem>
    //             <Divider />
    //         */}
    //         <MenuItem>
    //             <ListItemIcon>
    //                 <StrategicPlanningObjectiveIcon />
    //             </ListItemIcon>
    //             Objective
    //         </MenuItem>
    //         <MenuItem>
    //             <ListItemIcon>
    //                 <StrategicPlanningGoalIcon />
    //             </ListItemIcon>
    //             Goal
    //         </MenuItem>
    //         <MenuItem>
    //             <ListItemIcon>
    //                 <StrategicPlanningActionPlanIcon />
    //             </ListItemIcon>
    //             Action plan
    //         </MenuItem>
    //         <MenuItem disabled>
    //             <ListItemIcon>
    //                 <StrategicPlanningProjectIcon />
    //             </ListItemIcon>
    //             Project
    //         </MenuItem>
    //     </Menu>
    // );

    return (
        <>
            <Container sx={{ marginTop: 3 }}>
                <Stack spacing={5}>
                    {strategicPlanning?.objectives.map((objective, index) => (
                        <ObjectiveCard key={index} strategicPlanning={strategicPlanning} objective={objective} />
                    ))}
                </Stack>
            </Container>
        </>
    );
}
